import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'
import packageJson from '../../package.json'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

const pdfjsVersion = packageJson.dependencies['pdfjs-dist']

const PDFDisplay = ({ url }) => {
  // Set toolbar items to be hidden
  const transform = (slot) => ({
    ...slot,
    Open: () => <></>,
  })

  // Remove parts of the default layout toolbar
  const renderToolbar = () => (
    <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
  )
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
  })
  const { renderDefaultToolbar, Toolbar } =
    defaultLayoutPluginInstance.toolbarPluginInstance

  return (
    <Worker
      workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}
    >
      <div className="!h-[605px]">
        <Viewer
          fileUrl={url}
          plugins={[defaultLayoutPluginInstance]}
          defaultScale={SpecialZoomLevel.PageWidth}
        />
      </div>
    </Worker>
  )
}

export default PDFDisplay
